<template>
  <div>
    <div class="nav">
      <van-nav-bar
        title="科室类别"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
      />
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="元谋县元马镇卫生院（元谋县第二人民医院）新院区" name="1">
        <van-grid :column-num="3">
          <van-grid-item
            v-for="(item, index) in newdypeList[0]"
            :key="index"
            :text="item.deptName"
            @click="godetails_d(item)"
          />
        </van-grid>
      </van-collapse-item>
      <van-collapse-item title="元谋县元马镇卫生院（元谋县第二人民医院）老院区" name="4">
        <van-grid :column-num="3">
          <van-grid-item
            v-for="(item, index) in newdypeList[4]"
            :key="index"
            :text="item.deptName"
            @click="godetails_d(item)"
          />
        </van-grid>
      </van-collapse-item>      <van-collapse-item title="甘塘分院" name="2">
        <van-grid :column-num="3">
          <van-grid-item
            v-for="(item, index) in newdypeList[1]"
            :key="index"
            :text="item.deptName"
            @click="godetails_d(item)"
          />
        </van-grid>
      </van-collapse-item>
       <van-collapse-item title="能禹卫生院" name="3">
        <van-grid :column-num="3">
          <van-grid-item
            v-for="(item, index) in newdypeList[3]"
            :key="index"
            :text="item.deptName"
            @click="godetails_d(item)"
          />
        </van-grid>
      </van-collapse-item>
      <van-collapse-item title="卫生室" name="3">
        <van-grid :column-num="3">
          <van-grid-item
            v-for="(item, index) in newdypeList[2]"
            :key="index"
            :text="item.deptName"
            @click="godetails_d(item)"
          />
        </van-grid>
      </van-collapse-item>
    </van-collapse>
  
  </div>
</template>
<script>
import Nav from "./../../components/nav.vue";
export default {
  data() {
    return {
      activeNames: ["1"],
      newdypeList: [],
    };
  },
  mounted() {
    this.getrerinfo();
  },
  methods: {
    godetails_d(item) {
      this.$router.push({
        path: "/details_ymzyy",
        query: {
          deptid: item.deptId,
          dept_type: item,
          register_level: "N",
          regfre: item.cost,
        },
      });
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    async getDeptList() {
      //获取科室列表
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/register/querydept";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            if (this.wx_pub_id == "1012") {
              this.dypeList = data.data.data.filter((item) => {
                // console.log(item)
                return item.deptId != "183";
              });
            } else if (this.wx_pub_id == "1013") {
              this.dypeList = data.data.data.filter((item) => {
                // console.log(item)
                return (
                  item.deptId == "4" ||
                  item.deptId == "56" ||
                  item.deptId == "31"
                );
              });
            } else if (this.wx_pub_id == "1020") {
              let a = data.data.data.filter((item) => {
                // console.log(item)
                return item.deptId == "1176";
              });
              let b = data.data.data.filter((item) => {
                // console.log(item)
                return (
                  item.deptId != "1176" &&
                  item.deptId != "926" &&
                  item.deptId != "1135"
                );
              });
              this.dypeList = [...a, ...b];
            } else if (this.wx_pub_id == "3575") {
              this.dypeList = data.data.data.filter((item) => {
                // console.log(item)
                return item.deptId != "2"&&item.deptId !="82"&&item.deptId !="51";
              });

              this.dypeList.forEach((item) => {
                if (item.deptName == "医疗美容科") {
                  item.deptName = "医疗美容科          (皮肤科)";
                } else if (item.deptName == "健康体检室") {
                  item.deptName = "健康体检室          (儿童)";
                }else if(item.deptName == "元马镇马街卫生室"){
                  item.deptName = "马街卫生院 "
                }
              });
              let ymz = [];
              let gtfy = [];
              let wss = [];
              let nywsy = [];
              let old =[]
              ymz = this.dypeList.filter((item) => {
                return (
                  item.deptId == "102" ||
                  item.deptId == "103" ||
                  item.deptId == "108" ||
                  item.deptId == "109" ||
                  item.deptId == "106" ||
                  item.deptId == "7" ||
                  item.deptId == "55" ||
                  item.deptId == "6" ||
                  item.deptId == "57" ||
                  item.deptId == "90" ||
                  item.deptId == "110" ||
                  item.deptId == "51" 
                );
              });
              old= this.dypeList.filter(item=>{
                return item.deptId == "42" || 
                item.deptId == "21"||
                item.deptId == "107"||
                item.deptId == "20"||
                item.deptId == "59"||
                item.deptId == "52"||
                item.deptId == "45"||
                item.deptId == "86"||
                item.deptId == "59"
                ;
              })
              gtfy = this.dypeList.filter((item) => {
                return item.deptId == "44" || item.deptId == "85";
              });
              wss = this.dypeList.filter((item) => {
                return (
                  item.deptId == "38" ||
                  item.deptId == "66" ||
                  item.deptId == "76" ||
                  item.deptId == "69" ||
                  item.deptId == "71" ||
                  item.deptId == "67" ||
                  item.deptId == "72" ||
                  item.deptId == "73" ||
                  item.deptId == "74" ||
                  item.deptId == "82"
                );
              });
              nywsy = this.dypeList.filter((item) => {
                return (
                  item.deptId == "95" ||
                  item.deptId == "96" 
                );
              });
              this.newdypeList.push(ymz);
              this.newdypeList.push(gtfy);
              this.newdypeList.push(wss);
              this.newdypeList.push(nywsy);
              this.newdypeList.push(old);
              console.log(this.newdypeList);
            } else {
              this.dypeList = data.data.data;
            }

            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    //判断版本和排版类型
    async getrerinfo() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getdictionaries";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            //  console.log(data.data)
            this.wx_pub_id = data.data.wx_pub_id;
            // 挂号级别
            this.register_level = data.data.register.register_level;
            //  排班
            this.register_sched = data.data.register.register_sched;
            //  挂号类型
            this.register_type = data.data.register.register_type;
            this.getDeptList();
            if (this.wx_pub_id == "1012") {
              this.showDialog();
            }
            // if (register_sched == "Y") {
            //   //通过科室ID获取该科室下的挂号级别列表
            //   this.getDeptList();
            // } else if (this.register_sched == "N") {
            //   //显示挂号预约按钮
            //   //判断是否有挂号级别===》
            //   if (this.register_level == "Y") {
            //     this.getDeptList();
            //   } else if (this.register_level == "N") {
            //     this.regfre = data.data.register.price;
            //     this.Cflag = false;
            //     this.getDeptList();
            //   }
            // }
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-grid-item__content {
  height: 10vh;
}
::v-deep .van-grid-item__text {
  font-size: 16px;
}
</style>